<div class="flexi-compliance-page" *ngIf="!accessDenied; else denied">
  <header class="page-header">
    <h2>
      {{ 'FLEXI_COMPLIANCE_TEMPLATE.TITLE' | translate }}
      <span class="record-count" *ngIf="!loading">{{ templates.length }}</span>
    </h2>
    <p class="subtitle">{{ 'FLEXI_COMPLIANCE_TEMPLATE.SUBTITLE' | translate }}</p>
  </header>

  <div class="toolbar">
    <label class="toggle">
      <input type="checkbox" [(ngModel)]="includeDeleted" (change)="onToggleDeleted()" />
      {{ 'FLEXI_COMPLIANCE_TEMPLATE.LIST.INCLUDE_DELETED' | translate }}
    </label>
    <div class="toolbar-spacer"></div>
    <button class="btn btn-success" (click)="openWizard()">
      <i class="pi pi-plus"></i>
      {{ 'FLEXI_COMPLIANCE_TEMPLATE.LIST.NEW' | translate }}
    </button>
  </div>

  <div class="alert alert-danger" *ngIf="loadError">{{ loadError }}</div>

  <div *ngIf="loading" class="loading">
    <i class="pi pi-spin pi-spinner"></i>
  </div>

  <table class="data-table" *ngIf="!loading && templates.length > 0">
    <thead>
      <tr>
        <th>{{ 'FLEXI_COMPLIANCE_TEMPLATE.LIST.COLUMN_NAME' | translate }}</th>
        <th>{{ 'FLEXI_COMPLIANCE_TEMPLATE.LIST.COLUMN_CATALOG' | translate }}</th>
        <th>{{ 'FLEXI_COMPLIANCE_TEMPLATE.LIST.COLUMN_ITEMS' | translate }}</th>
        <th>{{ 'FLEXI_COMPLIANCE_TEMPLATE.LIST.COLUMN_BUSINESSES' | translate }}</th>
        <th>{{ 'FLEXI_COMPLIANCE_TEMPLATE.LIST.COLUMN_STATUS' | translate }}</th>
        <th></th>
      </tr>
    </thead>
    <tbody>
      <tr *ngFor="let t of templates" [class.row-deleted]="t.isDeleted">
        <td>
          <div class="template-info">
            <a href="javascript:void(0)" (click)="edit(t)">{{ t.name }}</a>
            <span class="muted" *ngIf="t.description">{{ t.description }}</span>
          </div>
        </td>
        <td><span class="version-tag">{{ t.catalogVersionCode }}</span></td>
        <td><span class="count-badge">{{ t.itemCount }}</span></td>
        <td><span class="count-badge">{{ t.businessAssignmentCount }}</span></td>
        <td>
          <span class="status-pill" [ngClass]="statusClass(t)">
            {{ statusKey(t) | translate }}
          </span>
        </td>
        <td>
          <div class="row-actions">
            <button class="btn btn-sm btn-outline-secondary" (click)="edit(t)">
              <i class="pi pi-pencil"></i>
              {{ 'FLEXI_COMPLIANCE_TEMPLATE.LIST.EDIT' | translate }}
            </button>
            <button class="btn btn-sm btn-danger"
                    (click)="remove(t)"
                    [disabled]="busyIds.has(t.id) || t.isDeleted">
              <i class="pi pi-trash"></i>
            </button>
          </div>
        </td>
      </tr>
    </tbody>
  </table>

  <div class="empty" *ngIf="!loading && templates.length === 0 && !loadError">
    <p>{{ 'FLEXI_COMPLIANCE_TEMPLATE.LIST.EMPTY' | translate }}</p>
    <button class="btn btn-success" (click)="openWizard()">
      <i class="pi pi-plus"></i>
      {{ 'FLEXI_COMPLIANCE_TEMPLATE.LIST.NEW' | translate }}
    </button>
  </div>
</div>

<ng-template #denied>
  <div class="flexi-compliance-page">
    <p class="empty">{{ 'FLEXI_COMPLIANCE_TEMPLATE.ACCESS_DENIED' | translate }}</p>
  </div>
</ng-template>
